import { useEffect, useState } from "react";

import { CountryCodes } from "@/constants/currency";
import useMetaCookies from "@/hooks/useMetaCookies";
import { useGeolocation } from "@/utils/GeolocationProvider";
import { readCookie } from "@/utils/readCookie";

const TTClickIdCookieName = "ttclid";
const TTCookieName = "_ttp";
const PinterestCookieName = "_epik";
const GoogleClickIdUrlParameterName = "gclid";
const useAdParameters = () => {
    const [tiktokClickId, setTiktokClickId] = useState<string | null>(null);
    const [tiktokCookie, setTiktokCookie] = useState<string | null>(null);
    const [pinterestCookie, setPinterestCookie] = useState<string | null>(null);
    const { ipAddress, country, city, postalCode, region } = useGeolocation();
    const params = new URLSearchParams(window ? window.location.search : {});
    const gclid = params.get(GoogleClickIdUrlParameterName);
    const metaCookies = useMetaCookies();

    useEffect(() => {
        const ttClickId = readCookie(TTClickIdCookieName);
        if (ttClickId) {
            setTiktokClickId(ttClickId);
        }
        const ttCookie = readCookie(TTCookieName);
        if (ttCookie) {
            setTiktokCookie(ttCookie);
        }
        const pintCookie = readCookie(PinterestCookieName);
        if (pintCookie) {
            setPinterestCookie(pintCookie);
        }
    }, []);

    return {
        ttClickId: tiktokClickId,
        ttCookie: tiktokCookie,
        userAgent: window.navigator.userAgent,
        ipAddress,
        epik: pinterestCookie,
        ...metaCookies,
        gclid,
        country,
        city,
        postalCode,
        state: country === CountryCodes.US ? region : undefined,
    };
};

export default useAdParameters;
